import { RichTextEditorInput as RichTextEditorAtom } from 'module/ui/components/atoms/rich-text-editor-input/editor';
import styled from 'styled-components';
import { withAiStyles } from './background-hoc';
import { withAiInput } from './input-hoc';

const RichTextEditor = styled(RichTextEditorAtom<string>)`
  .rte-editor {
    padding-right: 36px;
    background-color: transparent;

    .is-insert-only {
      caret-color: transparent;
    }

    .is-insert-only * {
      user-select: none;
    }

    /* Optional: visually blur or hide focus outline */
    .is-insert-only:focus {
      outline: none;
    }
  }
`;

export const AiRichTextEditor = withAiInput(withAiStyles(RichTextEditor));
